import * as React from 'react'
import {Button, Icon, InputNumber, Tooltip} from 'antd';
import {withTranslation, WithTranslation} from 'react-i18next';

import autobind from 'autobind-decorator';
import {isNumber} from 'util';

import EditableTooltip from 'src/components/editable-tooltip/tooltip'

export interface WeekHoursItem {
    minhours: number[],
    maxhours: number[]
}

interface WeekHoursEditorState {
    minhours: number[], maxhours: number[], firstEntry: boolean, confirm: boolean
}

interface WeekHoursEditorProps extends WithTranslation {
    value?: WeekHoursItem | undefined,
    onChange?: (value: WeekHoursItem) => any;   
    disabled?:boolean
}

export class WeekHoursEditor extends React.Component<WeekHoursEditorProps, WeekHoursEditorState> {
    constructor(props: WeekHoursEditorProps) {
        super(props);
        this.state = {
            minhours: props.value?.minhours || [0, 0, 0, 0, 0, 0, 0, 0],
            maxhours: props.value?.maxhours || [24, 24, 24, 24, 24, 24, 24, 168],            
            firstEntry: true,
            confirm: true
        }
    }

    static getDerivedStateFromProps(props: WeekHoursEditorProps, state: WeekHoursEditorState) {
        let item = props.value as any;
        if (JSON.stringify(item.minhours) != JSON.stringify(state.minhours) || JSON.stringify(item.maxhours) != JSON.stringify(state.maxhours)) {
           return {
                ...state,               
                minhours: item.minhours,
                maxhours: item.maxhours
            };
        }
        return state;
    }

    @autobind
    updateMinWeekHours(value: any, dayIndex: number) {
        if (this.props.disabled)
            return;
        
        let minhours = this.state.minhours;
        let maxhours = this.state.maxhours;
        let realValue = isNumber(value) ? value : 0
        if (realValue > maxhours[dayIndex]) {
            realValue = maxhours[dayIndex]
        }
        minhours[dayIndex] = realValue
        minhours[7] = minhours.reduce((a, b, i) => (i < 7) ? a + b : a)
        maxhours[7] = maxhours.reduce((a, b, i) => (i < 7) ? a + b : a)
        this.setState({  minhours , maxhours });
    }

    @autobind
    updateMaxWeekHours(value: any, dayIndex: number) {
        if (this.props.disabled)
            return;

        let maxhours = this.state.maxhours;
        let minhours = this.state.minhours
        let realValue = isNumber(value) ? Math.max(Math.min(value, 24), 0) : 0
        if (realValue < minhours[dayIndex] ) {
            return
        }
        maxhours[dayIndex] = realValue
        minhours[7] = minhours.reduce((a, b, i) => (i < 7) ? a + b : a)
        maxhours[7] = maxhours.reduce((a, b, i) => (i < 7) ? a + b : a)
        this.setState({ minhours, maxhours });
    }

    findSetDays(): number {
        for (var i = 0; i < this.state.minhours.length; i++) {
            if (this.state.minhours[i] > 0 && this.state.maxhours[i] > 0) {
                return i;
            }
        }
        return 7;
    }

    onChange(value: any, dayIndex: number, isMin: boolean) {
        if (isMin)
            this.updateMinWeekHours(value, dayIndex)
        else
            this.updateMaxWeekHours(value, dayIndex)
        if (this.props.onChange)
            this.props.onChange({
                minhours: this.state.minhours,
                maxhours: this.state.maxhours
            } as WeekHoursItem);
    }

    fill(value: any) {
        if (this.props.disabled)
            return;

        for (var j = 0; j < 5; j++) {
            this.updateMaxWeekHours(this.state.maxhours[value], j)
            this.updateMinWeekHours(this.state.minhours[value], j)
        }        
           
    }
   
    render() {
        const { t } = this.props;

        if (this.state.firstEntry) {
            this.setState({ firstEntry: false });   
        }

        return <>
                    <table className="ant-table-content">
                        <thead className="ant-table-thead">
                            <tr><th colSpan={4}>
                        <EditableTooltip name="weekhours-editors-hours-restrictions-per-week" noIcon>
                            
                            {t("Hours restrictions per week")} <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft:3 }} />
                            
                        </EditableTooltip></th>
                            </tr>
                            <tr>
                                <th>{t("Weekday")}</th>
                                <th>{t("Minimum hours")}</th>
                                <th>{t("Maximum hours")}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                            <tr>
                                <td>
                                    <span>{t("Monday")}</span>
                                </td>
                                <td>
                                        <InputNumber value={this.state.minhours[0]} style={{ width: '100%' }} onChange={ value => this.onChange(value,0,true)}  step={0.05} type='number' min={0} max={24}  />
                                </td>
                                <td>
                                        <InputNumber value={this.state.maxhours[0]} style={{ width: '100%' }} step={0.05} onChange={value => this.onChange(value, 0, false)} type='number' min={0} max={24} />
                                </td>
                                <td>
                                    <Tooltip title={t("Do you want to fill in the rest of the days with this time format?")}>
                                        <Button  onClick={() => this.fill(0) } shape="circle" icon={"edit"} style={{ visibility: (this.state.maxhours[0] + this.state.minhours[0] > 0 ? "visible":"hidden"  ) }} />
                                    </Tooltip>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Tuesday")}</span>
                                </td>
                                <td>
                                    <InputNumber value={this.state.minhours[1]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 1, true)} min={0} max={24} />
                                </td>
                                <td>
                                    <InputNumber value={this.state.maxhours[1]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 1, false)} min={0} max={24} />
                                </td>
                                <td>
                                <Tooltip title={t("Do you want to fill in the rest of the days with this time format?")}>
                                    <Button onClick={() => this.fill(1)} shape="circle" icon={"edit"} style={{ visibility: (this.state.maxhours[1] + this.state.minhours[1] > 0 ? "visible" : "hidden") }} />
                                    </Tooltip>
                                    </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Wednesday")}</span>
                                </td>
                                <td>
                                            <InputNumber value={this.state.minhours[2]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 2, true)} min={0} max={24} />
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[2]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 2, false)} min={0} max={24} />
                                </td>
                                <td>
                                <Tooltip title={t("Do you want to fill in the rest of the days with this time format?")}>
                                    <Button onClick={() => this.fill(2)} shape="circle" icon={"edit"} style={{ visibility: (this.state.maxhours[2] + this.state.minhours[2] > 0 ? "visible" : "hidden") }} />
                                    </Tooltip>
                                    </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Thursday")}</span>
                                </td>
                                <td>
                                            <InputNumber value={this.state.minhours[3]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 3, true)} min={0} max={24} />
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[3]} style={{ width: '100%' }} step={0.05} type='number' min={0} onChange={value => this.onChange(value, 3, false)} max={24} />
                                </td>
                                <td>
                                <Tooltip title={t("Do you want to fill in the rest of the days with this time format?")}>
                                    <Button onClick={() => this.fill(3)} shape="circle" icon={"edit"} style={{ visibility: (this.state.maxhours[3] + this.state.minhours[3] > 0 ? "visible" : "hidden") }} />
                                    </Tooltip>
                                    </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Friday")}</span>
                                </td>
                                <td>
                                            <InputNumber value={this.state.minhours[4]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 4, true)} min={0} max={24} />
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[4]} style={{ width: '100%' }} step={0.05} type='number' min={0} onChange={value => this.onChange(value, 4, false)} max={24} />
                                </td>
                                <td>
                                <Tooltip title={t("Do you want to fill in the rest of the days with this time format?")}>
                                    <Button onClick={() => this.fill(4)} shape="circle" icon={"edit"} style={{ visibility: (this.state.maxhours[4] + this.state.minhours[4] > 0 ? "visible" : "hidden") }} />
                                    </Tooltip>
                                    </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Saturday")}</span>
                                </td>
                                <td>
                                        
                                            <InputNumber value={this.state.minhours[5]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 5, true)} min={0} max={24} />
                                        
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[5]} style={{ width: '100%' }} step={0.05} type='number' min={0} max={24} onChange={value => this.onChange(value, 5, false)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("Sunday")}</span>
                                </td>
                                <td>
                                            <InputNumber value={this.state.minhours[6]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 6, true)} min={0} max={24} />
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[6]} style={{ width: '100%' }} step={0.05} type='number' onChange={value => this.onChange(value, 6, false)} min={0} max={24} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>{t("All week")}</span>
                                </td>
                                <td>
                                            <InputNumber value={this.state.minhours[7]} precision={2} style={{ width: "100%" }} disabled type="number" />
                                </td>
                                <td>
                                            <InputNumber value={this.state.maxhours[7]} precision={2} style={{ width: "100%" }} disabled type="number" />
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>

       </>
    }
}

// Wire up the React component to the Redux store
export default (withTranslation()(WeekHoursEditor) as any) as React.ComponentClass<WeekHoursEditorProps>;